import { all } from "redux-saga/effects";
import authSaga from "./authSaga";
import oemSaga from "./oemSaga";
import almataSaga from "./almataSaga";
import countrySaga from "./countrySaga";
import planSaga from "./planSaga";
import scanSaga from "./scanSaga";
import transactionSaga from "./transactionSaga";
import couponSaga from "./couponSaga";
import revenueSaga from "./revenueSaga";
import dashboardSaga from "./dashboard/dashboardSaga";
import profileSaga from "./profileSaga";
import emailVerificationSaga from "./emailVerificationSaga";
import itSalesSaga from "./itSalesSaga";
import settingSaga from "./settingSaga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    oemSaga(),
    almataSaga(),
    countrySaga(),
    planSaga(),
    scanSaga(),
    transactionSaga(),
    couponSaga(),
    revenueSaga(),
    dashboardSaga(),
    profileSaga(),
    itSalesSaga(),
    emailVerificationSaga(),
    settingSaga(),
  ]);
}
